<template>
  <div class="data-detail-container">
    <div class="data-detail-header">
      <div class="data-detail-header-left">
        <span style="color:#2A7EE3"> {{ data.name }}</span>
        <el-rate v-model="data.averageScore" disabled></el-rate>
      </div>
      <div class="data-detail-header-right">
        <span style="display:flex;algin-item:center;" @click="collcet(data.id)"
          ><img
            src="@/assets/icon_collect.png"
            style="width:16px;height:16px;margin-right:10px"
            alt=""
          />收藏</span
        >
        <router-link :to="'/help/index'">
          <span style="display:flex;algin-item:center;"
            ><img
              src="@/assets/icon_error.png"
              style="width:16px;height:16px;margin-right:10px"
              alt=""
            />纠错</span
          >
        </router-link>
      </div>
    </div>

    <table class="data-detail-table">
      <tbody>
        <tr>
          <td class="frist-td">摘要:</td>
          <td colspan="3">{{ data.name }}</td>
        </tr>
        <tr>
          <td class="frist-td">资源代码:</td>
          <td colspan="3">{{ data.code }}</td>
        </tr>
        <tr>
          <td class="frist-td">标签:</td>
          <td>{{ data.label }}</td>
          <td class="frist-td">更新周期：</td>
          <td>{{ data.updateCycle }}</td>
        </tr>
        <tr>
          <td class="frist-td">资源格式：</td>
          <td>{{ data.resourceFormat }}</td>
          <td class="frist-td">数源单位：</td>
          <td>{{ data.companyName }}</td>
        </tr>
        <tr>
          <td class="frist-td">数源单位地址：</td>

          <td>{{ data.companyAddress }}</td>

          <td class="frist-td">联系方式：</td>

          <td>{{ data.phone }}</td>
        </tr>
        <tr>
          <td class="frist-td">数据领域：</td>
          <td>{{ data.appTypeName }}</td>
          <td class="frist-td">访问/下载次数：</td>
          <td>
            {{ data.viewCount ? data.viewCount : 0 }}/{{
              data.downCount ? data.downCount : 0
            }}
          </td>
        </tr>
        <tr>
          <td class="frist-td">系统名称：</td>
          <td>{{ data.systemName }}</td>
          <td class="frist-td">评分/评价次数：</td>
          <td>
            {{ data.averageScore ? data.averageScore : 0 }}/{{
              data.scoreUserCount ? data.scoreUserCount : 0
            }}
          </td>
        </tr>
        <tr>
          <td class="frist-td">行业分类：</td>

          <td>{{ data.industryType }}</td>

          <td class="frist-td">数据预览：</td>
          <td>
            <router-link :to="'/data_public/detail/data_preview/' + data.id">
              <el-button type="primary" size="mini">预览</el-button>
            </router-link>

            <router-link
              :to="'/data_public/detail/data_preview/' + data.id + '?type=show'"
            >
              <el-button style="margin-left:10px;" type="primary" size="mini"
                >可视化</el-button
              >
            </router-link>
          </td>
        </tr>
        <tr>
          <td class="frist-td">数据分级：</td>

          <td>登录开放</td>

          <td class="frist-td">数据接口：</td>
          <td>
            <router-link
              v-if="data.showApi"
              :to="'/interface/detail/' + data.id"
              style="color:#2A7EE3"
              >API
            </router-link>
            <span v-else>无</span>
          </td>
        </tr>
        <tr>
          <td class="frist-td">开放条件：</td>

          <td>{{ data.openConditions }}</td>

          <td class="frist-td">数据范围：</td>

          <td>{{ data.dataRange }}</td>
        </tr>
        <tr>
          <td class="frist-td">更新日期：</td>
          <td>{{ data.lastUpdateTime }}</td>
          <td class="frist-td">发布日期：</td>
          <td>{{ data.createTime }}</td>
        </tr>
        <tr>
          <td class="frist-td">数据量：</td>
          <td>{{ data.dataCount ? data.dataCount : 0 }}</td>
          <td class="frist-td">数据图谱：</td>
          <td>
            <router-link :to="'/data_public/detail/data_atlas/' + data.id">
              <el-button type="primary" size="mini"
                >数据图谱</el-button
              ></router-link
            >
          </td>
        </tr>
        <tr>
          <td class="frist-td" height="64">数据下载：</td>
          <td>
            <div style="width:100%;display:flex;">
              <div
                v-if="data.hasxls"
                @click="goDown(data.name, 'XLS')"
                class="btn btn-primary"
              >
                XLS
              </div>
              <div
                v-if="data.hascsv"
                @click="goDown(data.name, 'CSV')"
                class="btn btn-primary"
              >
                CSV
              </div>
              <div
                v-if="data.hasxml"
                @click="goDown(data.name, 'XML')"
                class="btn btn-primary"
              >
                XML
              </div>
              <div
                v-if="data.hasjson"
                @click="goDown(data.name, 'JSON')"
                class="btn btn-primary"
              >
                JSON
              </div>
              <div
                v-if="data.hasrdf"
                @click="goDown(data.name, 'RDF')"
                class="btn btn-primary"
              >
                RDF
              </div>
            </div>
          </td>

          <td class="frist-td" height="64">历史数据下载：</td>
          <td>
            <div style="width:100%;display:flex;">
              <a
                target="_blank"
                v-if="data.hisxls"
                :href="data.hisxls"
                class="btn btn-primary btn-download-old"
                >XLS</a
              >
              <a
                target="_blank"
                v-if="data.hiscsv"
                :href="data.hiscsv"
                class="btn btn-primary btn-download-old"
                >CSV</a
              >
              <a
                target="_blank"
                v-if="data.hisxml"
                :href="data.xls"
                class="btn btn-primary btn-download-old"
                >XML</a
              >
              <a
                target="_blank"
                v-if="data.hisjson"
                :href="data.xls"
                class="btn btn-primary btn-download-old"
                >JSON</a
              >
              <a
                target="_blank"
                v-if="data.hisrdf"
                :href="data.xls"
                class="btn btn-primary btn-download-old"
                >RDF</a
              >
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="data-detail-info-box">
      <el-tabs
        type="border-card"
        v-model="activeName"
        class="data-detail-info-box"
      >
        <el-tab-pane label="数据项" name="first">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column
              fixed
              prop="filedName"
              label="字段名称"
              width="150px"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="enFiledName"
              label="英文名称"
              width="150px"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dataType"
              label="数据类型"
              width="150px"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dataDesc"
              label="字段描述"
              width="150px"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="dataLength" label="字段长度" align="center">
            </el-table-column>
            <el-table-column prop="isDict" label="是否字典项" align="center">
              <template v-slot="{ row }">{{
                row.isDict ? "是" : "否"
              }}</template></el-table-column
            >
            <el-table-column prop="isNull" label="是否为空" align="center">
              <template v-slot="{ row }">{{
                row.isNull ? "是" : "否"
              }}</template>
            </el-table-column>
            <el-table-column
              prop="isPrimaryKey"
              label="是否主键"
              align="center"
            >
              <template v-slot="{ row }">{{
                row.isPrimaryKey ? "是" : "否"
              }}</template>
            </el-table-column>
          </el-table></el-tab-pane
        >
        <!-- <el-tab-pane label="关联信息"
          ><div
            class="el-table__empty-block"
            style="height: 100%; width: 1197px;"
          >
            <span class="el-table__empty-text">暂无数据</span>
          </div></el-tab-pane
        > -->
        <!-- <el-tab-pane label="相关应用"
          ><div
            class="el-table__empty-block"
            style="height: 100%; width: 1197px;"
          >
            <span class="el-table__empty-text">暂无数据</span>
          </div></el-tab-pane
        > -->
      </el-tabs>
    </div>

    <div class="data-comment-box">
      <div class="comment-header">数据评论</div>
      <div class="comment-list">
        <div
          class="comment-item"
          v-for="(item, index) in remarkList"
          :key="index"
        >
          <div>Ip:{{ item.ipAddress }}</div>
          <div>{{ item.content }}</div>
          <div class="remake">
            <span>{{ item.time }}</span
            ><span>评分：{{ item.stars }}</span>
          </div>
          <div v-if="item.childenRemarks.length != 0" style="margin-top:0">
            <div>
              管理员回复：{{
                item.childenRemarks[0].content
                  ? item.childenRemarks[0].content
                  : ""
              }}
            </div>
            <div style="color:#a1a1a1;margin-top:10px">
              {{ item.childenRemarks[0] ? item.childenRemarks[0].time : "" }}
            </div>
          </div>
        </div>
      </div>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.curPageNumber"
        :page-sizes="pageData.pageSize"
        layout="total, sizes, prev, next, jumper"
        :total="pageData.total"
      >
      </el-pagination>
    </div>
    <remake type="DATA" :subjectId="id" />
  </div>
</template>
<script>
import {
  getDataSetDetail,
  getDataItemList,
  getDataSetList,
  getRemark
} from "@/api/index";

import { collcet, getDown } from "@/api/user";
import remake from "@/components/remake/index";
export default {
  components: {
    remake
  },
  data() {
    return {
      activeName: "first",
      commitList: [
        {
          title: "IP:60****78",
          content: "还行",
          created_at: "2020-04-22 14:38:43",
          total: 2
        },
        {
          title: "IP:60****78",
          content: "还行",
          created_at: "2020-04-22 14:38:43",
          total: 2
        },
        {
          title: "IP:60****78",
          content: "还行",
          created_at: "2020-04-22 14:38:43",
          total: 2
        }
      ],
      data: {},
      tableData: [],
      domainList: [],
      remarkList: [],
      pageData: {
        curPageNumber: 1,
        pageSize: 10,
        total: 0
      },
      id: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    async goDown(name, type) {
      var { result } = await getDown({ id: this.data.id, fileType: type });
      var eleLink = document.createElement("a");
      eleLink.download = name;
      eleLink.href = result;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
    },
    async collcet(id) {
      let { message } = await collcet({
        refId: id,
        collectName: this.data.name,
        collectType: "OPENDATA"
      });
      this.$message({
        message: message,
        type: "success"
      });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    async init() {
      this.id = this.$route.params.id;
      var data = await getDataSetDetail({ id: this.$route.params.id });
      this.data = data.result;
      var data1 = await getDataItemList({ datasetId: this.$route.params.id });
      var data2 = await getDataSetList({
        appTypeId: data.result.appTypeId,
        pageSize: 5
      });
      var data3 = await getRemark({
        id: this.$route.params.id,
        type: "data"
      });
      this.remarkList = data3.result.list;
      this.pageData.curPageNumber = data3.result.pager.curPageNumber;
      this.pageData.total = data3.result.pager.totalRecord;
      this.pageData.pageSize = data3.result.pager.pageSize;

      this.tableData = data1.result;
      this.domainList = data2.result.data;
    }
  }
};
</script>
<style lang="scss" scoped>
.data-detail-container {
  .el-form .el-form-item:first-child {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .btn-primary {
    padding: 3px 12px;
    font-size: 12px;
    font-weight: 400;
    color: #2a7ee3;
    border-radius: 2px;
    border: 1px solid #2a7ee3;
    margin-right: 10px;
    display: flex;
    text-align: center;
    flex-direction: row;
    align-items: center;
    height: 20px;
  }

  width: 100%;
  background: #ffffff;
  border: 1px solid #eeeeee;
  .data-comment-box {
    padding-bottom: 20px;
    .comment-list {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      margin-bottom: 30px;
      .comment-item {
        border-bottom: 1px dashed #e3e3e3;
        padding-bottom: 10px;
        > div {
          padding-left: 50px;
          margin-top: 10px;
          padding-right: 50px;
        }
        > .remake {
          font-size: 14px;
          font-weight: 400;
          color: #a1a1a1;
          line-height: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
      }
    }
    .comment-header {
      height: 50px;
      background: #2a7ee3;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 50px;
    }
  }
  .data-detail-info-box {
    margin-top: 30px;
    margin-bottom: 40px;
    height: 430px;
    .data-detail-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      width: 100%;
      height: 50px;
      background: #2a7ee3;
      > div {
        width: 150px;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      > div:first-child {
        background: #239dfc;
      }
    }
  }

  .data-detail-table {
    width: 100%;
    border-spacing: 0 !important;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    td {
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      height: 36px;
      padding-left: 15px;
    }
    tbody > tr > td:last-child {
      border-right: none;
    }
    tbody > tr:nth-child(even) {
      background: rgba(240, 240, 240, 0.3);
    }
    .frist-td {
      padding-left: 50px !important;
      width: 100px !important;
    }
  }
  .data-detail-header {
    padding: 0 215px 0 25px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    color: #2a7ee3;
    line-height: 22px;

    > div {
      display: inherit;
      span {
        margin-right: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
    }
    .data-detail-header-right {
      span {
        margin-right: 0px;
        margin-left: 50px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
    }
  }
}
</style>
